// Add your projects here. Each entry populates a card on the Portfolio page.
// `images` is an array — first item is the card thumbnail, all show in the modal gallery.
// Paths can be URLs or /public paths (e.g. "/portfolio/my-app.jpg")

export const projects = [
  {
    id: 1,
    title: "Amereston Construction",
    shortDescription: "Website for a Finnish-based construction company.",
    description:
      "A modern, responsive website built with Next.js and Tailwind CSS. Features a clean design with smooth animations, services overview, a project portfolio, an about us section and a contact form. Optimized for performance and SEO, with a custom CMS for easy content updates.",
    featuredImage: "/portfolio/amereston-logo.svg",
    images: [
      "/portfolio/amerestonHero.webp",
      "/portfolio/amereston1.webp",
      "/portfolio/amereston2.webp",
      "/portfolio/amereston3.webp",
    ],
    gradient: "from-graphite-silver to-graphite-crystal",
    lightGradient: true,
    tags: ["Next.js", "React", "Tailwind CSS", "SQLite"],
    category: "web",
    links: {
      live: "https://amereston.fi",
      github: null,
    },
    featured: true,
  },
  {
    id: 2,
    title: "Perxify",
    shortDescription:
      "AI-native Commerce Cloud platform enabling brands to build innovative commerce experiences.",
    description:
      "AI-native Commerce Cloud platform enabling brands to build innovative commerce experiences with analytics-driven insights through shared infrastructure.",
    featuredImage: "/portfolio/perxify_logo.jpg",
    images: ["/portfolio/perxify_logo.jpg"],
    gradient: "from-[#F4E9CB] to-[#F4E9CB]",
    lightGradient: true,
    tags: [
      "Node.js",
      "GraphQL",
      "PostgreSQL",
      "AWS",
      "Google Cloud",
      "TypeScript",
      "Python",
      "Docker",
      "Fastify",
    ],
    category: "cloud",
    links: {
      live: "https://perxify.com",
    },
    featured: true,
  },
  {
    id: 3,
    title: "Raamatuhai",
    shortDescription:
      "Book marketplace connecting readers and sellers with a seamless experience.",
    description:
      "Raamatuhai is a book marketplace connecting readers and sellers with a seamless experience. Built with React, Node.js, and GraphQL, it features user profiles, book listings, secure transactions, and a personalized recommendation engine. The platform fosters a vibrant community of book lovers while providing an intuitive interface for buying and selling books online.",
    featuredImage: "/portfolio/raamatuhai-logo.svg",
    images: ["/portfolio/raamatuhai-logo.svg"],
    gradient: "from-graphite-silver to-graphite-crystal",
    lightGradient: true,
    tags: ["React", "Node.js", "GraphQL", "Tailwind CSS"],
    category: "web",
    links: {
      live: "https://raamatuhai.ee",
      github: null,
    },
    featured: true,
  },
  {
    id: 4,
    title: "Palazzo Interiors Website",
    shortDescription:
      "A sleek, modern website for a high-end interior design firm.",
    description:
      "A sleek, modern website for a high-end interior design firm. Built in WordPress with a custom theme, it features a stunning portfolio gallery, an online store, detailed service and finished project pages, a blog, and a contact form. The design emphasizes elegance and sophistication, with smooth animations and a responsive layout that looks great on all devices.",
    featuredImage: "/portfolio/palazzo-logo-white.png",
    images: ["/portfolio/palazzo-logo-white.png"],
    gradient: "from-graphite-charcoal to-graphite-dark",
    lightGradient: false,
    tags: ["WordPress", "PHP", "JavaScript", "CSS"],
    category: "web",
    links: {
      live: "https://palazzo.ee",
      github: null,
    },
    featured: false,
  },
  {
    id: 5,
    title: "Idiot Mobile Game",
    shortDescription:
      "A web and android mobile game built with Next.js, React, Capacitor and Radix UI.",
    description:
      "A web and android mobile game built with Next.js, React, Capacitor and Radix UI. Features engaging gameplay, smooth animations and an AI opponent with multiple difficulty levels. Optimized for performance and user experience across both web and mobile platforms.",
    featuredImage: "/portfolio/idiot-icon.svg",
    images: ["/portfolio/idiot1.webp"],
    gradient: "from-[#1C4024] to-[#1C4024]",
    lightGradient: false,
    tags: ["Next.js", "React", "Capacitor", "Radix UI"],
    category: "game",
    links: {
      live: "https://play.google.com/store/apps/details?id=com.graphbyte.idiotcardgame",
      github: null,
    },
    featured: false,
  },
  {
    id: 6,
    title: "World of Freight",
    shortDescription:
      "Supply Chain-themed Gaming Ecosystem with Dynamic Vehicle & Driver NFTs and fully On-Chain Game",

    description:
      "World of Freight is a supply chain-themed gaming ecosystem built on the blockchain. It features dynamic vehicle and driver NFTs that evolve based on in-game performance, creating a unique blend of gaming and DeFi. The game is fully on-chain, allowing players to earn rewards and trade assets in a decentralized marketplace. With engaging gameplay and a vibrant community, World of Freight offers an innovative experience for gamers and crypto enthusiasts alike.",
    featuredImage: "/portfolio/wof-logo.svg",
    images: ["/portfolio/wof-logo.svg"],
    gradient: "from-graphite-charcoal to-graphite-dark",
    lightGradient: false,
    tags: ["Solidity", "Web3.js", "React", "Next.js", "Tailwind CSS"],
    category: "game",
    links: {
      live: "https://worldoffreight.xyz",
      github: null,
    },
    featured: false,
  },
];

export const categories = [
  { id: "all", label: "All" },
  { id: "web", label: "Web" },
  { id: "cloud", label: "Cloud" },
  { id: "game", label: "Games" },
  { id: "mobile", label: "Mobile" },
];
